import { render, staticRenderFns } from "./ConsumoTab.vue?vue&type=template&id=6d061b0d&scoped=true"
import script from "./ConsumoTab.vue?vue&type=script&lang=js"
export * from "./ConsumoTab.vue?vue&type=script&lang=js"
import style0 from "./ConsumoTab.vue?vue&type=style&index=0&id=6d061b0d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d061b0d",
  null
  
)

export default component.exports